import { Device } from "@capacitor/device";
import { isNative, platform } from "./native";
import type { ClientInfo } from "./net/protocol";

/** Describes this build and device for auth.login. */
export async function getClientInfo(): Promise<ClientInfo> {
  const info: ClientInfo = { version: __APP_VERSION__, build: buildNumber(), platform };
  // On the web these are guessed from the user agent and not worth sending.
  if (isNative) {
    try {
      const device = await Device.getInfo();
      if (device.osVersion) info.os = device.osVersion.slice(0, 32);
      if (device.model) info.model = device.model.slice(0, 64);
    } catch {
      // Optional fields.
    }
  }
  if (navigator.language) info.locale = navigator.language.slice(0, 35);
  return info;
}

function buildNumber(): number {
  const build = Number(import.meta.env.VITE_BUILD_NUMBER ?? 0);
  return Number.isSafeInteger(build) && build >= 0 ? build : 0;
}
